import LoginPageImage from '@/components/_core/ui/auth-page-image/index.vue';
import HeaderDefault from '@/components/_core/ui/header/index.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  middleware : '_core/anonymous',
  components : {
    HeaderDefault,
    LoginPageImage
  },
  head() {
    return {
      title         : this.headTitle,
      titleTemplate : `%s :: ${process.env.APPLICATION_TITLE}`,
      meta          : [
        { name: 'theme-color', content: this.themes.light.primary },
        { name: 'msapplication-navbutton-color', content: this.themes.light.primary },
        { name: 'apple-mobile-web-app-status-bar-style', content: this.themes.light.primary }
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: this.themes.favicon, id: '#favicon' }
      ]
    };
  },
  beforeMount() {
    this.$root.$i18n.locale = this.$core.getDefaultLocale();
  },
  data() {
    return {
      configBorder : '',
      fluid        : true,
      statusMini   : false,
      filter       : true
    };
  },
  computed: {
    ...mapGetters({
      dark: '_core/application/isDark'
    }),
    ...mapState({
      themes: state => state._core.application.themes
    }),
    headTitle() {
      return this.$t('_core.common.loading');
    }
  },
  watch: {
    statusMini() {
      this.fluid = !this.fluid;
      this.configBorder = this.fluid ? 'px-0' : '';
    }
  }
};
